module.exports = __webpack_public_path__ + "img/blue-circles.39c9ddd9.svg";